import type {Optional} from '@yandex-delivery/types'
import {applySpec, find, flow, get, identity, ifElse, isUndefined} from '@yandex-delivery/utils'

import type {PaymentInfo, PaymentMethodFinance, PaymentMethodsListResponse} from 'src/shared/types'

const buildPaymentInfo: (paymentMethodFinance?: PaymentMethodFinance) => PaymentInfo = applySpec<PaymentInfo>({
  type: get('display.type'),
  method_id: get('id'),
})

const findSelectedMethod: (response?: PaymentMethodsListResponse) => Optional<PaymentMethodFinance> = flow(
  get('methods'),
  find(item => get('is_selected', item)),
)

const toPaymentMethodFinance: (paymentMethodFinance: Optional<PaymentMethodFinance>) => Optional<PaymentInfo> = ifElse(
  isUndefined,
  identity,
  buildPaymentInfo,
)

const toPaymentMethodFromResponse: (response?: PaymentMethodsListResponse) => Optional<PaymentInfo> = flow(
  findSelectedMethod,
  toPaymentMethodFinance,
)

export function toPaymentInfo(paymentListResponse: Optional<PaymentMethodsListResponse>) {
  return Object.assign(
    {
      kind: get('selected_method.payment_method_kind', paymentListResponse),
    },
    toPaymentMethodFromResponse(paymentListResponse),
  )
}
